import { render, staticRenderFns } from "./ModalInfoApp.vue?vue&type=template&id=68472d92&scoped=true"
import script from "./ModalInfoApp.vue?vue&type=script&lang=js"
export * from "./ModalInfoApp.vue?vue&type=script&lang=js"
import style0 from "./ModalInfoApp.vue?vue&type=style&index=0&id=68472d92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68472d92",
  null
  
)

export default component.exports